import { render, staticRenderFns } from "./GestaoAcessoForm.vue?vue&type=template&id=3df1c3f7&scoped=true&"
import script from "./GestaoAcessoForm.vue?vue&type=script&lang=js&"
export * from "./GestaoAcessoForm.vue?vue&type=script&lang=js&"
import style0 from "./GestaoAcessoForm.vue?vue&type=style&index=0&id=3df1c3f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df1c3f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})
